"use client";

import { useState, useEffect } from "react";
import { useLanguage } from "../hooks/useLanguage";
import HeroSection from "../components/homepage/HeroSection";
import QuickMenuSection from "../components/homepage/QuickMenuSection";
import PartyPresidentSection from "../components/homepage/PartyPresidentSection";
import OurInspirationSection from "../components/homepage/OurInspirationSection";
import EventSection from "../components/homepage/EventSection";
import IssueSection from "../components/homepage/IssueSection";
import PressReleaseSection from "../components/homepage/PressReleaseSection";
import ArticleSection from "../components/homepage/ArticleSection";
import PhotoSection from "../components/homepage/PhotoSection";
import VideoSection from "../components/homepage/VideoSection";
import SocialStreamSection from "../components/homepage/SocialStreamSection";
import PollsFloatingCard from "../components/homepage/PollsFloatingCard";

import config from "../config/config";

export default function Page() {
  const [showPresidentInspiration, setShowPresidentInspiration] = useState(true);
  const [loading, setLoading] = useState(true);
  const { language } = useLanguage();

  useEffect(() => {
    // Check if president and inspiration sections have data
    const checkSections = async () => {
      try {
        const response = await fetch(`${config.NEXT_PUBLIC_API_URL}/api/public/settings/homepage/president?language=${language}`);
        const inspirationResponse = await fetch(`${config.NEXT_PUBLIC_API_URL}/api/public/settings/homepage/inspiration?language=${language}`);
        
        const presidentData = await response.json();
        const inspirationData = await inspirationResponse.json();
        
        const hasPresident = presidentData.success && presidentData.data.item;
        const hasInspiration = inspirationData.success && inspirationData.data.item;
        
        // Only show wrapper if at least one section has data
        setShowPresidentInspiration(hasPresident || hasInspiration);
      } catch (error) {
        setShowPresidentInspiration(false);
      } finally {
        setLoading(false);
      }
    };

    checkSections();
  }, [language]);

  return (
    <>
      <div className="bg-background ">
        {/* Hero Section */}
        <HeroSection />

        {/* President and Inspiration Sections - Side by Side */}
        {showPresidentInspiration && (
          <div className="py-6 sm:py-8 md:py-10 lg:py-12 xl:py-14 px-2 sm:px-3 md:px-4 lg:px-6">
            <div className="max-w-7xl mx-auto w-full">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 sm:gap-4 md:gap-6 lg:gap-8">
                <PartyPresidentSection />
                {/* Dashed separator for small devices */}
                <div className="lg:hidden border-t border-dashed border-gray-300 my-1"></div>
                <OurInspirationSection />
              </div>
            </div>
          </div>
        )}

       
 
        {/* Events Section */}
        <EventSection />

        {/* Issues Section */}
        <IssueSection />

       

        {/* Photos Section */}
        <PhotoSection />

       

        {/* Videos Section */}
        <VideoSection />

       

        {/* Press Release Section */}
        <PressReleaseSection />

       

        {/* Article Section */}
        <ArticleSection />

        {/* Social Stream Section */}
        <SocialStreamSection />
      </div>

      {/* Polls Floating Card */}
      <PollsFloatingCard />
      
      {/* Quick Menu Floating Component */}
      <QuickMenuSection />
    </>
  );
}
